import { Component, forwardRef, Input } from "@angular/core";
import { AssetPickerModalService } from "../../../../modals/asset-picker/asset-picker.modal.service";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AssetHierarchyResponse } from "source/app/configuration/services/api.service";

@Component({
	selector: "app-assignment-asset",
	templateUrl: "./assignment-asset.component.html",
	styleUrls: ["./assignment-asset.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => AssignmentAssetComponent),
			multi: true,
		},
	],
})
export class AssignmentAssetComponent implements ControlValueAccessor {
	constructor(private assetPickerModalService: AssetPickerModalService) {}
	@Input() assets: AssetHierarchyResponse;
	@Input() v2 = false;
	public asset: DocumentReference;

	selectAsset = async () => {
		const modal = await this.assetPickerModalService.create(this.assets);
		modal.present();

		const result = await modal.onDidDismiss();

		if (result.role === "save") {
			this.asset = result.data;
			this.onTouched();
			this.onFormChange(result.data);
		}
	};

	onFormChange = (_asset: DocumentReference) => {};
	onTouched = () => {};

	disabled = false;

	writeValue(asset: DocumentReference): void {
		this.asset = asset;
	}

	registerOnChange(fn: (asset: DocumentReference) => void): void {
		this.onFormChange = fn;
	}
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
